
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { requiredBoolean } from './required-boolean.validator';

export function getUpdateItemDtoFormGroup() {
return new FormGroup({
    productgroupId: new FormControl<number | undefined>(undefined),
    unitId: new FormControl<number | undefined>(undefined),
    vendorId: new FormControl<number | undefined>(undefined),
    producerId: new FormControl<number | undefined>(undefined),
    number: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(200)]),
    shortname: new FormControl<string | undefined>(undefined, [Validators.maxLength(50)]),
    orderNumber: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    ean: new FormControl<string | undefined>(undefined, [Validators.maxLength(20)]),
    ighSupplierId: new FormControl<number | undefined>(undefined),
    ighSubCatalogKey: new FormControl<string | undefined>(undefined, [Validators.maxLength(64)]),
    ighArticleNumber: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    ighListPriceChf: new FormControl<number | undefined>(undefined),
    optional: new FormControl<boolean | undefined>(false),
    additional: new FormControl<boolean | undefined>(false),
    nompower: new FormControl<number | undefined>(undefined),
    nompowerBlack: new FormControl<number | undefined>(undefined),
    warranty: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    length: new FormControl<number | undefined>(undefined),
    lengthUnitId: new FormControl<number | undefined>(undefined),
    width: new FormControl<number | undefined>(undefined),
    widthUnitId: new FormControl<number | undefined>(undefined),
    height: new FormControl<number | undefined>(undefined),
    heightUnitId: new FormControl<number | undefined>(undefined),
    weight: new FormControl<number | undefined>(undefined),
    weightUnitId: new FormControl<number | undefined>(undefined),
    transportunit: new FormControl<number | undefined>(undefined),
    oProductTitle: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    oProductText: new FormControl<string | undefined>(undefined),
    umpp: new FormControl<number | undefined>(undefined),
    impp: new FormControl<number | undefined>(undefined),
    uoc: new FormControl<number | undefined>(undefined),
    isc: new FormControl<number | undefined>(undefined),
    irueck: new FormControl<number | undefined>(undefined),
    efficiency: new FormControl<number | undefined>(undefined),
    notesInternal: new FormControl<string | undefined>(undefined),
    notesExternal: new FormControl<string | undefined>(undefined),
    active: new FormControl<boolean | undefined>(true, [requiredBoolean()]),
    visibleForCustomer: new FormControl<boolean | undefined>(false),
    visibleForCalculator: new FormControl<boolean | undefined>(false),
    containertypeId: new FormControl<number | undefined>(undefined),
    diameter: new FormControl<number | undefined>(undefined),
    diameterUnitId: new FormControl<number | undefined>(undefined),
    noiseEmission: new FormControl<number | undefined>(undefined),
    installationLocation: new FormControl<string | undefined>(undefined),
    refrigerant: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    hailProtectionClass: new FormControl<string | undefined>(undefined, [Validators.maxLength(50)]),
    maxChargePower: new FormControl<number | undefined>(undefined),
    maxDischargePower: new FormControl<number | undefined>(undefined),
    emergencyPower: new FormControl<boolean | undefined>(undefined),
    type: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
})
;
}
      